import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import cn from './cn.json'
import en from './en.json'

Vue.use(VueI18n)

const messages = {
  en,
  cn
}

const i18n = new VueI18n({
  locale: Cookies.get('jdcloud_sitelang') || 'cn',
  fallbackLocale: 'cn',
  messages
})

export default i18n
